import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Grid,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { ReactComponent as RightIcon } from '../../../../../assets/img/icon/Right.svg';
import SubHeader from '../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../components/LoaderSplash/Loader.component';
import SuraCard from '../../../../../components/SuraCard';
import { useSinisterInspectionsContext } from '../../../../../context/SinisterInspections/SinisterInspections.provider';

const AUTO_INSPECTION_CARDS = [
  {
    hidden: false,
    content: 'Inspección por foto',
    subtitle: 'Podés inspeccionar cargando vos mismo tus fotos',
    link: '/photographic-inspection',
  },
];

const INSPECTION_CARDS = [
  {
    hidden: false,
    content: 'Talleres de GESTIÓN RÁPIDA',
    subtitle: 'Lista de talleres para inspección sin turno',
    link: '/fast-management',
  },
  {
    hidden: false,
    content: 'Coordinar inspección en taller',
    subtitle: 'Agendá tu verificación en el taller que desees',
    link: '/mechanical-inspection',
  },
];

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    cardMobile: {
      '& img': {
        minHeight: '65px',
      },
      [theme.breakpoints.down('xs')]: {
        margin: theme.spacing(1),
      },
    },
    cardText: {
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    hiddenContainer: {
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    subtitle: {
      color: '#768692',
      fontWeight: 400,
    },
  })
);

const SinisterMethod = () => {
  const classes = useStyle();
  const { cleanSuccess } = useSinisterInspectionsContext();

  useEffect(() => {
    cleanSuccess();
  }, [cleanSuccess]);

  return (
    <>
      {/* <Box display={loading ? 'block' : 'none'}>
                <Loader action={'Cargando denuncias'}></Loader>
            </Box> */}

      <SubHeader
        content={
          <Box>
            <Typography variant="h6">Coordinar una inspección</Typography>
          </Box>
        }
      ></SubHeader>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box my={4}>
            <Typography variant="h6">
              {' '}
              ¿Como te gustaría inspeccionar?{' '}
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className={classes.subtitle}>
              Recordá que si ya tenés agendada tu inspección, no es necesario
              que vuelvas a inspeccionar o agendar una nueva.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={3} mb={2}>
            <Typography> ¡Autogestioná tu inspección! </Typography>
          </Box>
        </Grid>

        {AUTO_INSPECTION_CARDS.map((card: any, index: number) => (
          <Grid
            item
            xs={12}
            md={11}
            key={index}
            className={card.hidden && classes.hiddenContainer}
          >
            <Box mx={1} mb={3}>
              <ButtonBase
                component={Link}
                to={card.link}
                style={{ width: '100%' }}
              >
                <SuraCard>
                  <Box
                    m={1}
                    display="flex"
                    justifyContent="space-around"
                    alignItems="center"
                    width="100%"
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width={'90%'}
                      className={classes.cardMobile}
                    >
                      <Box>
                        <Box className={classes.cardText}>
                          <Typography variant="h6">{card.content}</Typography>
                        </Box>
                        <Box className={classes.cardText}>
                          <Typography className={classes.subtitle}>
                            {card.subtitle}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <RightIcon></RightIcon>
                      </Box>
                    </Box>
                  </Box>
                </SuraCard>
              </ButtonBase>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={3} mb={2}>
            <Typography>
              Llevá tu vehículo a un taller para que nuestros inspectores puedan
              revisarlo
            </Typography>
          </Box>
        </Grid>
        {INSPECTION_CARDS.map((card: any, index: number) => (
          <Grid
            item
            xs={12}
            md={11}
            key={index}
            className={card.hidden && classes.hiddenContainer}
          >
            <Box mx={1} mb={3}>
              <ButtonBase
                component={Link}
                to={card.link}
                style={{ width: '100%' }}
              >
                <SuraCard>
                  <Box
                    m={1}
                    display="flex"
                    justifyContent="space-around"
                    alignItems="center"
                    width="100%"
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width={'90%'}
                      className={classes.cardMobile}
                    >
                      <Box>
                        <Box className={classes.cardText}>
                          <Typography variant="h6">{card.content}</Typography>
                        </Box>
                        <Box className={classes.cardText}>
                          <Typography className={classes.subtitle}>
                            {card.subtitle}
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <RightIcon></RightIcon>
                      </Box>
                    </Box>
                  </Box>
                </SuraCard>
              </ButtonBase>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default SinisterMethod;
